import { Button } from '@eventbrite/eds-button';
import { Icon } from '@eventbrite/eds-icon';
import { MagnifyingGlassChunky } from '@eventbrite/eds-iconography';
import { InputField } from '@eventbrite/eds-input-field';
import { gettext } from '@eventbrite/i18n';
import { FALLBACK_SUGGESTIONS } from '@eventbrite/site-header';
import React from 'react';
import './GlobalHeaderSearch.scss';

export const getSearchInfo = (
    serverUrl: string,
    query: string,
    suggestions = FALLBACK_SUGGESTIONS,
) => {
    return {
        formAction: `${serverUrl}/d/`,
        label: gettext('Search'),
        query,
        suggestions,
    };
};

const GlobalHeaderSearch = ({
    searchInfo,
    setRenderSearchTakeover,
    containerClassName = 'consumer-header__search',
}: {
    searchInfo?: any;
    id: string;
    onSelect?: Function;
    onSubmit?: Function;
    borderType?: string;
    onChange?: Function;
    suffix?: string;
    hasMinAsideSpacing?: boolean;
    shouldRenderSearchTakeover?: boolean;
    setRenderSearchTakeover: Function;
    isHomePage: boolean;
    isBrowsePage: boolean;
    containerClassName?: string;
    formClassName?: string;
}) => {
    if (!searchInfo) {
        return null;
    }

    return (
        <div className={containerClassName} data-spec="consumer-header-search">
            <Button
                onClick={() => setRenderSearchTakeover(true)}
                style="none"
                size="block"
                data-testid="consumer-global-header-search"
                __containerClassName="consumer-header__search--button"
            >
                <InputField
                    disabled={true}
                    label={gettext('Search for events')}
                    id="header-event-search-button"
                    style="basic"
                    placeholder={gettext('Search events')}
                    prefix={
                        <Icon color="ui-600" type={<MagnifyingGlassChunky />} />
                    }
                    role="button"
                />
            </Button>
        </div>
    );
};

export default GlobalHeaderSearch;
